const willChange = {
  name: "will-change",
  path: "will-change",
  title: "will-change",
  description: "Utilities for optimizing upcoming animations of elements that are expected to change.",
  value: {
    "will-change": {
      "will-change-auto": "none",
      "will-change-transform": "transform",
      "will-change-scroll-position": "scroll-position",
      "will-change-contents": "contents",
      "will-change-[<value>]": "<value>"
    }
  },
  exampleData: [
    {
      title: "will-change-scroll, will-change-transform, will-change-contents",
      description: "utilities to optimize an element that's expected to change in the near future by instructing the browser to prepare the necessary animation before it actually begins",
      example: {
        code: `<div class="will-change-scroll ...">will-change-scroll: Prepare for scroll position change.</div>
<div class="will-change-transform ...">will-change-transform: Prepare for transform change.</div>
<div class="will-change-contents ...">will-change-contents: Prepare for contents change.</div>`
      }
    }
  ]
};

export default willChange;